import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Regiao} from '../../comum/modelos/regiao';
import {RegiaoService} from '../regiao.service';
import {ComumService} from '../../comum/comum.service';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-cadastro-regiao',
  templateUrl: './cadastro-regiao.component.html',
  styleUrls: ['./cadastro-regiao.component.css']
})
export class CadastroRegiaoComponent implements OnInit {

  regiao: Regiao;

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  statusCode: number;
  public loading = false;

  constructor(
    private _regiaoService: RegiaoService,
    private _comumService: ComumService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private _authService: AuthService) {
    this.regiao = new Regiao();
  }

  ngOnInit() {
    const id = this._activatedRoute.snapshot.params['id'];
    this.loading = true;
    if (id !== undefined) {
      const self = this;
      this._regiaoService.obterRegiaoPorIdHttp(id)
        .subscribe((regiao: Regiao) => {
          self.regiao = regiao;
          self.MODO = this.ATUALIZAR;
          self.loading = false;
        });
    } else {
      this.MODO = this.CADASTRAR;
      this.loading = false;
    }
  }

  onSubmit(): void {
    this.loading = true;
    const self = this;

    if (this.MODO === this.CADASTRAR) {
      this._regiaoService.cadastrarRegiaoHttp(this.regiao)
        .subscribe(response => {
          self.loading = false;
          self.statusCode = response.status;
          self._comumService.evento.cadastro = true;
          self.router.navigate(['listar-regioes']);
        }, errorCode => {
          self.statusCode = errorCode;
          self.loading = false;
        });
    } else {
      this._regiaoService.atualizarRegiaoHttp(this.regiao)
        .subscribe(response => {
          self.loading = false;
          self.statusCode = response.status;
          self._comumService.evento.atualizar = true;
          self.router.navigate(['listar-regioes']);
          console.log(response);
        }, errorCode => {
          self.statusCode = errorCode;
          self.loading = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/regiao/cadastro-regiao/cadastro-regiao.component.ts